import { makeStyles, css } from '@conexasaude/conexa-hero'

const useStyles = makeStyles({
  cardContainer: css`
    display: block;
    max-width: 435px;
    width: 290px;
    box-sizing: border-box;
    transition: 0.2s;
    cursor: pointer;
  `,

  cardProfessionalInfo: ({ colors }) => css`
    > div {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      span {
        color: ${colors.neutral[400]};
      }
    }
  `,

  cardConsultationInfo: ({ colors, spacing }) => css`
    border-top: 1px solid ${colors.neutral[100]};
    > div {
      + div {
        margin-top: ${spacing.xs};
      }
    }
  `,

  cardConsultationTag: ({ spacing }) => css`
    margin-top: ${spacing.xxs};
    margin-bottom: ${spacing.xs};
  `,

  base: ({ spacing }) => css`
    display: flex;
    align-items: center;
    div {
      margin-left: ${spacing.xxs};
    }
  `,

  cardWrapperFooter: ({ spacing }) => css`
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    padding-top: ${spacing.xs};
  `,

  cardLinkFooter: ({ spacing }) => css`
    margin-top: ${spacing.xs};
  `,
})

export { useStyles }
